import { assureString,ensure_list } from './../../type_utils/src/ensure_utils.js';
export function getSubstring(obj: string, maxLength: number | null = null, minLength: number | null = null): string {
  const objLength = obj.length;
  const effectiveMaxLength = maxLength ?? objLength; // Use nullish coalescing for clarity
  const effectiveMinLength = minLength ?? 0;

  // Ensure bounds are valid
  const clampedMaxLength = Math.min(Math.max(effectiveMaxLength, 0), objLength);
  const clampedMinLength = Math.min(Math.max(effectiveMinLength, 0), objLength);

  // If minLength exceeds maxLength, return empty string or adjust logic as needed
  if (clampedMinLength >= clampedMaxLength) {
    return '';
  }

  return obj.substring(clampedMinLength, clampedMaxLength);
}

/**
 * Sanitize a string by removing null bytes and trimming whitespace.
 */
export function sanitizeString(input: string): string {
  if (!input) return input;
  return input.replace(/\u0000/g, "").trim(); // Remove null bytes and whitespace
}

export function truncateString(obj: string, maxLength: number = 20): string {
  const objLength = obj.length;
  if (objLength > maxLength && maxLength) {
    obj = getSubstring(obj, maxLength) + '...';
  }
  return obj;
}

export function capitalize_str(string: any) {
  string = assureString(string);
  const string_len = string.length;
  let init_char = string.toUpperCase();
  if (string_len > 0) {
    init_char = string[0].toUpperCase();
  }
  let rest_chars = '';
  if (string_len > 1) {
    rest_chars = string.slice(1).toLowerCase();
  }
  const fin_chars = `${init_char}${rest_chars}`;
  return fin_chars;
}

export function capitalize(string: any) {
  let nu_string = '';
  string = assureString(string);
  const objs = string.replace('-', '_').split('_');
  for (const obj of objs) {
    const str_obj = capitalize_str(obj);
    nu_string = `${nu_string} ${str_obj}`;
  }
  return eatAll(nu_string, [' ']);
}
// string_utils/src/string_utils.ts
export function stripPrefixes(
  str: string,
  bases: string | string[] = []
): string {
  /* NEW: coerce whatever arrives into a string */
  str = String(str);

  const prefixes = (Array.isArray(bases) ? bases : [bases])
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);         // longest first

  let changed = true;
  while (changed) {
    changed = false;
    for (const prefix of prefixes) {
      if (str.startsWith(prefix)) {
        str = str.slice(prefix.length);
        changed = true;
        break;            // restart from longest prefix
      }
    }
  }
  return str;
}
export function tryEatPrefix(
  str: string,
  length: number,
  ...objs: any[]
): [string, boolean] {
  str = String(str);
  objs = ensure_list(objs);

  const prefix = str.slice(0, length);
  if (length < 0) {
    const start = str.length + length;
    const actualPrefix = str.slice(start);
    return objs.includes(actualPrefix) ? [str.slice(0, start), true] : [str, false];
  }

  if (objs.includes(prefix)) {
    return [str.slice(length), true];
  }

  return [str, false];
}

/** Python-equivalent eatInner */
export function eatInner(str: any, listObjects: any): string {
  str = String(str);
  const chars = Array.isArray(listObjects) ? listObjects : [listObjects];

  // Keep removing from left while leftmost char is in the set
  while (str.length > 0 && chars.includes(str[0])) {
    str = str.slice(1);
  }
  return str;
}

/** Python-equivalent eatOuter */
export function eatOuter(str: any, listObjects: any): string {
  str = String(str);
  const chars = Array.isArray(listObjects) ? listObjects : [listObjects];

  if (!str || chars.length === 0) return str;

  for (let i = 0; i < str.length; i++) {
    if (!str) return str;
    const last = str[str.length - 1];
    if (!chars.includes(last)) {
      return str;
    }
    str = str.slice(0, -1);
  }
  return str;
}

/** Python-equivalent eatAll */
export function eatAll(str: any, listObjects: any): string {
  str = String(str);
  const chars = Array.isArray(listObjects) ? listObjects : [listObjects];

  str = eatInner(str, chars);
  str = eatOuter(str, chars);

  return str;
}

// Plug in the actual version from your project
function get_alpha_ints(opts: {
  ints?: boolean;
  alpha?: boolean;
  lower?: boolean;
  capitalize?: boolean;
  string?: boolean;
  listObj?: boolean;
}) {
  // REPLACE WITH YOUR REAL IMPLEMENTATION
  return [];
}

/** Python-equivalent eatElse */
export function eatElse(
  stringObj: any,
  chars?: any,
  ints = true,
  alpha = true,
  lower = true,
  capitalize = true,
  string = true,
  listObj = true
): string {
  stringObj = String(stringObj);

  const alphaInts = get_alpha_ints({
    ints,
    alpha,
    lower,
    capitalize,
    string,
    listObj,
  });

  const ls = ensure_list(chars || []).concat(alphaInts);

  while (true) {
    if (!stringObj) return stringObj;

    const startOk = !ls.includes(stringObj[0]);
    const endOk = !ls.includes(stringObj[stringObj.length - 1]);
    const shouldEat = startOk || endOk;

    if (!shouldEat) return stringObj;

    if (stringObj && startOk) {
      stringObj = stringObj.length === 1 ? "" : stringObj.slice(1);
    }

    if (stringObj && endOk) {
      stringObj = stringObj.length === 1 ? "" : stringObj.slice(0, -1);
    }
  }
}


export function tryParse(obj: any) {
  try {
    obj = JSON.stringify(obj)
  } catch (err) {
    try {
      obj = JSON.parse(obj)
    } catch (err) {

    }
  }
  return obj;
}
export function create_list_string(array_obj: any) {
  let string = ''
  for (const obj in array_obj) {
    const array_value = array_obj[obj]
    const parsed_value = tryParse(array_value)
    string += `${obj} == ${parsed_value}\n`

  }
  return string
}

export function eatall(
	str: any, listObjects: any
	):string {
		return eatAll(str, listObjects);
	}


export function eatinner(
	str: any, listObjects: any
	):string {
		return eatInner(str, listObjects);
	}


export function eatouter(
	str: any, listObjects: any
	):string {
		return eatOuter(str, listObjects);
	}
